
export const DocData: {[country: string]: string[]} = require('./data.json')
